const WORDS_TO_NOT_BE_CAPITALIZED = new Set([
  'a',
  'an',
  'as',
  'at',
  'and',
  'but',
  'by',
  'for',
  'from',
  'in',
  'nor',
  'of',
  'on',
  'or',
  'so',
  'to',
  'up',
  'with',
  'yet',
]);

/**
 * Converts a given string to title case.
 *
 * The function trims the input string, converts it to lowercase, and then capitalizes the first letter of each word.
 * Certain words (defined in `WORDS_TO_NOT_BE_CAPITALIZED`) are not capitalized unless they are the first word in the string.
 *
 * @param v - The input string to be converted to title case.
 * @returns The title-cased string. If the input string is empty or null, an empty string is returned.
 */
export const titleCase = (v: string): string => {
  if (!v) return '';

  return v
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .map((word, i) => {
      if (i === 0 || !WORDS_TO_NOT_BE_CAPITALIZED.has(word)) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }

      return word;
    })
    .join(' ');
};
